// extracted by mini-css-extract-plugin
export default {"menu":"RelatedSessionsMenu_menu__LNv7f","menuItem":"RelatedSessionsMenu_menuItem__HbQUu"};